<template>
  <div>
    <div class="header-box" v-if="isH5">
      <PageMbHeader
        :title="title"
        :transShow="false"
        :transOpen="false"
        :iconShow="!isNewTab"
        @icon-click="back"
      />
    </div>
    <div class="rule-education">
      <div class="info-content">
        <div v-for="(detail, index) in educationInfo" :key="'detail' + index">
          <div class="tit" :ref="detail.type" :id="detail.type">
            {{ detail.secTitle }}
          </div>
          <div
            class="desc"
            v-for="(desc, index) in detail.list"
            :key="'desc' + index"
          >
            {{ desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';
import { mapState } from 'vuex';
import { getBrandName } from '@/utils/getCountyConfig';
import PageMbHeader from '@/components/PageMbHeader';
import { getIsNewTab } from '@/utils/tools';

export default {
  name: 'rule-education',
  data() {
    return {};
  },
  components: { PageMbHeader },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    brandName() {
      return getBrandName('brand_txt_2');
    },
    title() {
      const deliveryTypeDesc = get(this, '$route.query.deliveryTypeDesc', '');
      return this.$t(
        'FoodC_education__unk_aOCD',
        {
          delivery_type: deliveryTypeDesc,
        } /*{{delivery_type}}平台规则*/
      );
    },
    educationInfo() {
      const res = [
        {
          type: 'takeMeal',
          secTitle: this.$t('FoodC_education_Meal_picking_ziun' /* 取餐规则 */),
          list: [
            this.$t(
              'FoodC_education_In_order_AZCw',
              {
                brand_name: this.brandName,
              } /* 为了使您在{{brand_name}}服务中有更好的体验，平台特制订取餐规则，以供各方遵守。涉及顾客取餐纠纷的场景，将按照如下规则处理 */
            ),
            this.$t(
              'FoodC_education_Basic_requirements_hIbv' /* 顾客取餐基本要求 */
            ),
            this.$t(
              'FoodC_education_1_Customers_Gpbb' /* 1. 顾客可在下单前选择交餐方式，平台会要求骑手按照顾客所选择的方式进行处理： */
            ),
            this.$t('FoodC_education__1_vwgm' /* (1）送货上门 */),
            this.$t('FoodC_education__2_jwSo' /* (2）放在门口（文字备注） */),
            this.$t(
              'FoodC_education_2_Receiving_gFZl' /* 2. 收餐地址、联系方式填写正确； */
            ),
            this.$t(
              'FoodC_education_3_Customers_Zoec' /* 3. 顾客需要保持手机畅通，便于骑手联系取餐； */
            ),
            this.$t(
              'FoodC_education_4_Customers_laxR' /* 4. 顾客需要骑手到户后10分钟内及时取餐； */
            ),
            this.$t(
              'FoodC_education_5_Cash_zBuY' /* 5. 如下现金支付订单，顾客需准备充足的现金，现金付款后取餐； */
            ),
            this.$t(
              'FoodC_education_Principles_of_RKEk' /* 取餐纠纷处理原则 */
            ),
            this.$t(
              'FoodC_education_1_If_iWDm' /* 1. 如顾客未按照上述要求取餐，导致交餐纠纷，优先顾客承担责任，具体场景包括且不限于： */
            ),
            this.$t('FoodC_education__1_qvVC' /* （1）顾客取餐超时 */),
            this.$t('FoodC_education__2_KZTZ' /* （2）骑手联系不上顾客 */),
            this.$t('FoodC_education__3_TDsa' /* （3）顾客拒收餐品 */),
            this.$t('FoodC_education__4_QYXm' /* （4）顾客拒绝支付现金单 */),
            this.$t(
              'FoodC_education_2_If_SoSk' /* 2. 若骑手未按照平台规范完成交餐，导致交餐纠纷，优先骑手承担责任 */
            ),
            this.$t(
              'FoodC_education_3_If_wduh' /* 3. 若因产品问题、天气问题等非人为因素导致交餐纠纷，平台承担责任 */
            ),
          ],
        },
        {
          type: 'cancel',
          secTitle: this.$t(
            'FoodC_education_Cancellation_Policy_fxrl' /* 取消规则 */
          ),
          list: [
            this.$t(
              'FoodC_education_In_order_SRIb',
              {
                brand_name: this.brandName,
              } /* 为了使您在{brand_name}服务中有更好的体验，平台特制订取消规则，以供各方遵守。 */
            ) +
              this.$t(
                'FoodC_education_If_you_RTIV' /* 您成功支付外卖价款后，如需要取消订单的，将按照如下规则进行： */
              ),
            this.$t(
              'FoodC_education_In_the_MKeB' /* 下列取消订单的情形下，您无需承担责任： */
            ),
            this.$t(
              'FoodC_education__1_IIfh' /* （1）在商家接单前，您可以在订单详情页通过‘取消订单’功能进行取消 */
            ),
            this.$t(
              'FoodC_education__2_uVUK' /* （2）因商家未营业、商品售罄、发生意外等原因订单被商家或骑手取消，订单费用将全部退回； */
            ),
            this.$t(
              'FoodC_education__3_ltNM' /* （3）因分配不到骑手等平台原因或外部原因导致订单取消的情形 */
            ),
            this.$t(
              'FoodC_education_In_the_nIgD' /* 下列取消订单的情形下，您需承担责任： */
            ),
            this.$t(
              'FoodC_education__1_mJTG' /* （1）如果商家已确认接单，您可通过‘取消订单‘功能与商家协商申请取消订单；如商家因已出餐等合理理由不同意取消订单，您将不能免费取消订单；如您坚持取消订单或者拒收餐品，则订单相关费用将由您全部承担； */
            ),
            this.$t(
              'FoodC_education__2_KHhl' /* （2）如您超过平台规定的时间未到达交餐点、订单地址填写错误、收餐号码错误、拒接送餐人员电话、无正当理由拒收餐品，您需要支付订单费用 */
            ),
          ],
        },
      ];
      return res;
    },
    isNewTab() {
      return getIsNewTab();
    },
  },
  created() {
    const deliveryTypeDesc = get(this, '$route.query.deliveryTypeDesc', '');
    const title = this.$t('FoodC_education__unk_aOCD', {
      delivery_type: deliveryTypeDesc,
    });
  },
  mounted() {
    const locate = get(this, '$route.query.locate', '');
    this.gotoTitle(locate);
    const orderId = get(this, '$route.query.orderId', '');
    const orderStatus = get(this, '$route.query.orderStatus', '');
    this.$trackEvent({
      eventId: 'sailing_c_x_order_delivery_rule_sw',
      eventLabel: '订单配送规则曝光',
      attrs: {
        order_id: orderId,
        order_status: orderStatus,
      },
    });
  },
  methods: {
    gotoTitle(type) {
      if (!type) {
        return;
      }
      const typeObj = document.getElementById(type);
      const height = get(typeObj, 'offsetTop', 0);
      if (!height) {
        return;
      }
      document.getElementsByClassName('rule-education')[0].scrollTop =
        height - 17;
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../control_global.scss';
.header-box {
  position: relative;
}
.rule-education {
  height: calc(100vh - 180px);
  overflow-y: auto;
  margin: 60px auto;
  max-width: 470px;
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px;
}
.info-content {
  padding: 0 0 68px 0;
}
.info-content .tit {
  font-family: 'Aspira Medium';
  font-size: 24px;
  line-height: 28px;
  color: #000000;
  padding-top: 12px;
  margin-bottom: 20px;
}

.info-content .desc {
  font-family: 'Aspira Thin';
  font-size: 14px;
  line-height: 18px;
  color: #000000;
  text-align: justify;
  margin-bottom: 18px;
}

// 移动端适配
@media screen and (max-width: 768px) {
  .header-box {
    position: sticky;
    top: 0;
    z-index: 9;
  }
  .cate-header-wrapper {
    position: relative;
  }
  .rule-education {
    height: auto;
    min-height: calc(100vh -#{rem(40)});
    margin: 0 auto;
    max-width: auto;
    background: #fff;
    padding: rem(40) rem(40) 0;
  }
  .info-content {
    padding: 0 0 rem(68) 0;
    .tit {
      font-family: 'Aspira Medium';
      font-size: rem(36);
      line-height: rem(42);
      color: #000000;
      margin-bottom: rem(34);
    }
    .desc {
      font-family: 'Aspira Thin';
      font-size: rem(28);
      line-height: rem(34);
      color: #000000;
    }
  }
}
</style>